/* eslint-disable array-callback-return */
import React from 'react';
import _merge from 'lodash/merge';
import { default as TypographyWrapper } from '@mui/material/Typography';
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color as getColor } from "../../utils/index.js";
var COMPONENT = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span',
  DIV: 'div'
};
var ALIGN = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right'
};
var TYPE = {
  CONTRAST_TEXT: 'contrastText',
  MAIN: 'main'
};
var DIRECTION = {
  LTR: 'ltr',
  RTL: 'rtl'
};
export var Typography = function Typography(_ref) {
  var variant = _ref.variant,
    component = _ref.component,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? COLOR_VARIANTS.MINESHAFT : _ref$color,
    colorType = _ref.colorType,
    align = _ref.align,
    strike = _ref.strike,
    children = _ref.children,
    className = _ref.className,
    noWrap = _ref.noWrap,
    gutterBottom = _ref.gutterBottom,
    sx = _ref.sx,
    testId = _ref.testId,
    direction = _ref.direction;
  return /*#__PURE__*/React.createElement(TypographyWrapper, {
    variant: variant,
    component: component,
    color: getColor(color, colorType),
    align: align,
    "data-testid": testId,
    gutterBottom: gutterBottom,
    noWrap: noWrap,
    className: "__ds__comp ".concat(className),
    sx: _merge({
      textDecoration: strike ? 'line-through' : '',
      direction: direction || ''
    }, sx)
  }, children);
};